import React from 'react';
import proptypes from 'prop-types';

const { string, oneOfType, number } = proptypes;

const PointrStoreLayout = ({
  storeId, storeName, aisle, bay
}) => {
  return (
    <div data-component="PointrStoreLayout" data-testid="pointr-store-layout">
      <p>Pointr Store Map — Coming Soon (Store: {storeName} #{storeId}, Aisle: {aisle}, Bay: {bay})</p>
    </div>
  );
};

PointrStoreLayout.displayName = 'PointrStoreLayout';

PointrStoreLayout.propTypes = {
  storeId: string.isRequired,
  storeName: string.isRequired,
  aisle: oneOfType([number, string]),
  bay: oneOfType([number, string])
};

PointrStoreLayout.defaultProps = {
  aisle: null,
  bay: null
};

export { PointrStoreLayout };
